import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api, fileUrl } from "@/lib/api";
import { LogIn, ShieldAlert, UserCircle2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [cfg, setCfg] = useState(null);
  const err = params.get("error");
  const denied = params.get("denied");

  useEffect(() => {
    api.get("/configuracoes").then(({ data }) => setCfg(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!loading && user?.is_admin) nav("/admin", { replace: true });
  }, [loading, user, nav]);

  const login = () => {
    const redirect = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const logoPath = cfg?.logo ? cfg.logo.replace("/api/files/", "") : null;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="bbh-card p-8 space-y-6">
          <div className="flex items-center gap-4">
            {logoPath ? (
              <img src={fileUrl(logoPath)} alt="BBH" className="w-14 h-14 object-contain" />
            ) : (
              <div className="w-14 h-14 rounded-md bg-[#14243D] text-white flex items-center justify-center font-heading font-bold text-xl">B</div>
            )}
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500">
                Área restrita
              </div>
              <h1 className="font-heading text-2xl font-bold tracking-tight">
                {cfg?.nome_empresa || "BBH"} · Orçamentos
              </h1>
            </div>
          </div>

          <p className="text-sm text-zinc-600">
            Entre com sua conta Google autorizada para acessar o painel administrativo.
          </p>

          {(err || denied) && (
            <div className="bg-rose-50 border border-rose-200 rounded-md p-3 text-rose-700 text-sm flex gap-2" data-testid="login-error">
              <ShieldAlert className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>{denied
                ? "Esta conta Google não tem permissão para acessar o painel."
                : "Não foi possível concluir o login. Tente novamente."}</span>
            </div>
          )}

          <button
            onClick={login}
            data-testid="login-google-btn"
            className="w-full inline-flex items-center justify-center gap-3 px-4 py-3 rounded-md bg-white border border-zinc-300 hover:bg-zinc-50 font-medium"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5" xmlns="http://www.w3.org/2000/svg">
              <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.44c-.29 1.48-1.14 2.73-2.42 3.58v3h3.9c2.29-2.11 3.57-5.22 3.57-8.82z"/>
              <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.9-3c-1.08.72-2.45 1.16-4.03 1.16-3.09 0-5.71-2.09-6.65-4.9H1.32v3.07C3.31 21.3 7.31 24 12 24z"/>
              <path fill="#FBBC05" d="M5.35 14.35A7.19 7.19 0 0 1 4.95 12c0-.83.15-1.63.4-2.35V6.58H1.32A11.98 11.98 0 0 0 0 12c0 1.94.46 3.77 1.32 5.42l4.03-3.07z"/>
              <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.94 1.19 15.24 0 12 0 7.31 0 3.31 2.7 1.32 6.58l4.03 3.07C6.29 6.84 8.91 4.75 12 4.75z"/>
            </svg>
            Entrar com Google
          </button>

          <div className="pt-4 border-t border-zinc-200 text-xs text-zinc-500 text-center">
            Somente administradores autorizados têm acesso ao painel.
          </div>

          <Link
            to="/portal/login"
            data-testid="login-portal-cliente-link"
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-[#14243D] hover:bg-[#0f1a2e] text-white text-sm font-semibold"
          >
            <UserCircle2 className="w-4 h-4" /> Sou cliente — acessar meus orçamentos
          </Link>
        </div>

        <div className="mt-4 text-center text-xs text-zinc-400">
          <LogIn className="w-3 h-3 inline mr-1" /> BBH Serviços · Sistema de Orçamentos
        </div>
      </div>
    </div>
  );
}
